import './App.css';
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { auth } from './firebase';

// Auth Components
import Login from './auth/Login';
import Register from './auth/Register';
import Forgetpass from './auth/Forgetpass';

// Layout Panels
import Header from './panel/Header';
import Menu from './panel/Menu';
import Footer from './panel/Footer';
import Disabled from './panel/Disabled';
import Notfound from './panel/Notfound';
import Help from './panel/Help';

// Core Components
import Dashboard from './components/Dashboard';
import Uploaddocuments from './panel/Uploaddocuments';
import Property from './components/Property';
import Roomdetails from './components/Roomdetails';
import Roomfacilities from './components/Roomfacilities';
import Amenities from './components/Amenities';
import Rules from './components/Rules';
import Propimages from './components/Propimages';
import Rateplans from './components/Rateplans';
import Roomtarrifs from './components/Roomtarrifs';
import Roomavailability from './components/Roomavailability';
import Roomno from './components/Roomno';
import Rateupdates from './components/Rateupdates';
import Roomrates from './components/Roomrates';
import Userlogins from './components/Userlogins';
import Paymodes from './components/Paymodes';
import Bookingtypes from './components/Bookingtypes';
import Extraservices from './components/Extraservices';
import Cmconnection from './components/Cmconnection';

// Reservation Components
import Viewreservations from './components/reservations/Viewreservations';
import Reservationdetails from './components/reservations/Reservationdetails';
import Checkouts from './components/reservations/Checkouts';
import Hotelinvoice from './components/reservations/Hotelinvoice';
import Roomcleaned from './components/reservations/Roomcleaned';
import Roomcleanings from './components/reservations/Roomcleaning';
import Reserveroom from './components/reservations/Reserveroom';

// Report Components
import Pendingpayments from './components/reports/Pendingpayments';
import Allbookingreport from './components/reports/Addbookingreport';
import Receptionistreport from './components/reports/Receptionistreport';
import Logindetails from './components/reports/Logindetails';
import Userlogs from './components/reports/Userlogs';
import Paymodewise from './components/reports/Paymodewise';
import Bookingtypewise from './components/reports/Bookingtypewise';
import Roomtypewiseonline from './components/reports/Roomtypewise';
import Datewisebooking from './components/reports/Datewisebooking';
import Damagenotes from './components/reports/Damagenotes';

import RoomList from './components/cmconnection/Roomlist';
import Otainfo from './components/cmconnection/Otainfo';
import Rateudates from './components/cmconnection/Rateudates';
import Inventiryupdate from './components/cmconnection/Inventiryupdate';
import Otabookings from './components/cmconnection/Otabookings';
import Webenquiry from './components/Onlinebookings/Webenquiry';

// Custom Wrapper Component to toggle layout frames cleanly
const DashboardLayout = ({ children }) => {
  return (
    <>
      <Header />
      <Menu />
      {children}
      <Footer />
    </>
  );
};

function App() {
  const [user, setUser] = useState(null);
  const [initializing, setInitializing] = useState(true);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setUser(user);
      setInitializing(false);
    });
    return unsubscribe;
  }, []);

  if (initializing) return null; // Prevents flashing white screens while loading auth state

  return (
    <div className="wrapper">
      <Router>
        <Routes>
          {/* Public Auth Routes (No headers, menus or footers) */}
          <Route path="/" element={!user ? <Login /> : <Navigate to="/home" replace />} />
          <Route path="/login" element={!user ? <Login /> : <Navigate to="/home" replace />} />
          <Route path="/Register" element={!user ? <Register /> : <Navigate to="/home" replace />} />
          <Route path="/forgot-password" element={!user ? <Forgetpass /> : <Navigate to="/home" replace />} />

          {/* Protected Main Admin Panels (Wrapped in Dashboard layout) */}
          <Route path="/ota-bookings" element={user ? <DashboardLayout><Otabookings /></DashboardLayout> : <Navigate to="/login" replace />} />

          <Route path="/website-enquiries" element={user ? <DashboardLayout><Webenquiry /></DashboardLayout> : <Navigate to="/login" replace />} />
          <Route path="/home" element={user ? <DashboardLayout><Dashboard /></DashboardLayout> : <Navigate to="/login" replace />} />
          <Route path="/reservation" element={user ? <DashboardLayout><Reserveroom /></DashboardLayout> : <Navigate to="/login" replace />} />
          <Route path="/dcr-report" element={user ? <DashboardLayout><Allbookingreport /></DashboardLayout> : <Navigate to="/login" replace />} />
          <Route path="/receptionist-report" element={user ? <DashboardLayout><Receptionistreport /></DashboardLayout> : <Navigate to="/login" replace />} />
          <Route path="/login-details" element={user ? <DashboardLayout><Logindetails /></DashboardLayout> : <Navigate to="/login" replace />} />
          <Route path="/user-logs" element={user ? <DashboardLayout><Userlogs /></DashboardLayout> : <Navigate to="/login" replace />} />
          <Route path="/paymodewise-report" element={user ? <DashboardLayout><Paymodewise /></DashboardLayout> : <Navigate to="/login" replace />} />
          <Route path="/booking-typewise-report" element={user ? <DashboardLayout><Bookingtypewise /></DashboardLayout> : <Navigate to="/login" replace />} />
          <Route path="/roomtypewise-report" element={user ? <DashboardLayout><Roomtypewiseonline /></DashboardLayout> : <Navigate to="/login" replace />} />
          <Route path="/datewise-bookings" element={user ? <DashboardLayout><Datewisebooking /></DashboardLayout> : <Navigate to="/login" replace />} />
          <Route path="/pending-payments" element={user ? <DashboardLayout><Pendingpayments /></DashboardLayout> : <Navigate to="/login" replace />} />
          <Route path="/cleaned-rooms" element={user ? <DashboardLayout><Roomcleaned /></DashboardLayout> : <Navigate to="/login" replace />} />
          <Route path="/cleaning-rooms" element={user ? <DashboardLayout><Roomcleanings /></DashboardLayout> : <Navigate to="/login" replace />} />
          <Route path="/print-invoice/:documentId" element={user ? <DashboardLayout><Hotelinvoice /></DashboardLayout> : <Navigate to="/login" replace />} />
          <Route path="/checkouts" element={user ? <DashboardLayout><Checkouts /></DashboardLayout> : <Navigate to="/login" replace />} />
          <Route path="/reservation-details/:documentId" element={user ? <DashboardLayout><Reservationdetails /></DashboardLayout> : <Navigate to="/login" replace />} />
          <Route path="/live-reservations" element={user ? <DashboardLayout><Viewreservations /></DashboardLayout> : <Navigate to="/login" replace />} />
          <Route path="/view-reservations" element={user ? <DashboardLayout><Viewreservations /></DashboardLayout> : <Navigate to="/login" replace />} />
          <Route path="/disabled-property" element={user ? <DashboardLayout><Disabled /></DashboardLayout> : <Navigate to="/login" replace />} />
          <Route path="/property-documents" element={user ? <DashboardLayout><Uploaddocuments /></DashboardLayout> : <Navigate to="/login" replace />} />
          <Route path="/property-details" element={user ? <DashboardLayout><Property /></DashboardLayout> : <Navigate to="/login" replace />} />
          <Route path="/room-types" element={user ? <DashboardLayout><Roomdetails /></DashboardLayout> : <Navigate to="/login" replace />} />
          <Route path="/room-information" element={user ? <DashboardLayout><Roomno /></DashboardLayout> : <Navigate to="/login" replace />} />
          <Route path="/room-facilities" element={user ? <DashboardLayout><Roomfacilities /></DashboardLayout> : <Navigate to="/login" replace />} />
          <Route path="/amenties" element={user ? <DashboardLayout><Amenities /></DashboardLayout> : <Navigate to="/login" replace />} />
          <Route path="/rules-and-regulations" element={user ? <DashboardLayout><Rules /></DashboardLayout> : <Navigate to="/login" replace />} />
          <Route path="/property-images" element={user ? <DashboardLayout><Propimages /></DashboardLayout> : <Navigate to="/login" replace />} />
          <Route path="/rate-plans" element={user ? <DashboardLayout><Rateplans /></DashboardLayout> : <Navigate to="/login" replace />} />
          <Route path="/room-rate-plans" element={user ? <DashboardLayout><Roomtarrifs /></DashboardLayout> : <Navigate to="/login" replace />} />
          <Route path="/room-availability" element={user ? <DashboardLayout><Roomavailability /></DashboardLayout> : <Navigate to="/login" replace />} />
          <Route path="/help-support" element={user ? <DashboardLayout><Help /></DashboardLayout> : <Navigate to="/login" replace />} />
          <Route path="/rates-updates" element={user ? <DashboardLayout><Rateupdates /></DashboardLayout> : <Navigate to="/login" replace />} />
          <Route path="/room-rates" element={user ? <DashboardLayout><Roomrates /></DashboardLayout> : <Navigate to="/login" replace />} />
          <Route path="/user-logins" element={user ? <DashboardLayout><Userlogins /></DashboardLayout> : <Navigate to="/login" replace />} />
          <Route path="/payment-modes" element={user ? <DashboardLayout><Paymodes /></DashboardLayout> : <Navigate to="/login" replace />} />
          <Route path="/booking-types" element={user ? <DashboardLayout><Bookingtypes /></DashboardLayout> : <Navigate to="/login" replace />} />
          <Route path="/extra-services" element={user ? <DashboardLayout><Extraservices /></DashboardLayout> : <Navigate to="/login" replace />} />
          <Route path="/damage-notes" element={user ? <DashboardLayout><Damagenotes /></DashboardLayout> : <Navigate to="/login" replace />} />
          <Route path="/channel-manager-connectivity" element={user ? <DashboardLayout><Cmconnection /></DashboardLayout> : <Navigate to="/login" replace />} />
          <Route path='/inventory-updates' element={<Inventiryupdate />} />
          <Route path='/rate-updates' element={<Rateudates />} />
          <Route path='/ota-info' element={<Otainfo />} />
          <Route path='/room-list' element={<RoomList />} />

          {/* Catch All / 404 Route */}
          <Route path="*" element={<Notfound />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;